import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { useGridApiContext } from '@mui/x-data-grid-premium';

import { findTaskStatus, tasksStatuses } from '../../../root/Container/Layout/Tasks/Task/taskConstants';

export default function StatusEditCell({ id, field, row }) {
  const apiRef = useGridApiContext();

  return (
    <Autocomplete
      options={tasksStatuses}
      value={findTaskStatus(row.status)}
      onChange={(_, newValue) => {
        if (newValue) {
          apiRef.current.setEditCellValue({ id, field, value: newValue.id });
          apiRef.current.stopCellEditMode({ id, field });
        }
      }}
      onClose={(_, reason) => {
        if (reason !== 'selectOption') {
          apiRef.current.stopCellEditMode({ id, field });
        }
      }}
      getOptionLabel={option => option.name}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      disableClearable
      fullWidth
      open
      sx={{ px: 1 }}
      renderInput={params => (
        <TextField
          {...params}
          autoFocus
          size="small"
          variant="standard"
          sx={{
            '.MuiInputBase-root': { '::before': { border: 'none !important' } },
            '.MuiInputBase-input': { fontSize: '0.875rem' }
          }}
        />
      )}
    />
  );
}
